
import { useState, useEffect } from 'react';
import QRCode from "qrcode";

export const useBookingQRCode = (booking: any, isCancelled: boolean) => {
  const [qrCodeDataUrl, setQrCodeDataUrl] = useState<string>("");

  // Generate QR code when booking is available (for all confirmed, non-cancelled bookings)
  useEffect(() => {
    const generateQRCode = async () => {
      if (booking && !isCancelled) {
        try {
          const managementUrl = `https://wellsuites.co/management/booking/${booking.id}`;
          const qrDataUrl = await QRCode.toDataURL(managementUrl, {
            width: 200,
            margin: 2,
            color: {
              dark: '#000000',
              light: '#FFFFFF'
            }
          });
          setQrCodeDataUrl(qrDataUrl);
        } catch (error) {
          console.error('Error generating QR code:', error);
        }
      }
    };

    generateQRCode();
  }, [booking, isCancelled]);

  return { qrCodeDataUrl };
};
